import { Component, Input, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { TimeService } from '@core/services/common/time.service';
import { SessionStorageService } from '@core/services/common';
import { EXCREATIONSCREEN } from '@core/constants';
import { SESSION_STORAGE_KEY } from '@core/configs';
import { Utils } from '@core/helper';

@Component({
  selector: 'caremoni-final-treatment',
  templateUrl: './final-treatment.component.html',
  styleUrl: './final-treatment.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FinalTreatmentComponent implements OnInit, OnDestroy {
  @Input() data: any = {};
  @Input() config: any = null;

  timeDifferenceString: string = '';
  private updateIntervalSub!: Subscription;
  dayDifference: number = 0;
  hourDifference: number = 0;
  hasExcreationRecord: boolean = false;

  warningType: number = 0;
  warningColor: 'red' | 'yellow' | '' = 'red';
  dataMarquee: any = { message: '', screen: EXCREATIONSCREEN.EXCREATION };

  constructor(
    private timeService: TimeService,
    private sessionStorageService: SessionStorageService
  ) { }

  ngOnInit(): void {

    this.calculateTimeDifference();
    // auto update time system
    this.updateIntervalSub = interval(60 * 1000).subscribe(() => {
      this.calculateTimeDifference();
    });
  }
  ngOnDestroy(): void {
    if (this.updateIntervalSub) {
      this.updateIntervalSub.unsubscribe();
    }
  }
  get blinkClass(): string {
    return this.warningType != 0 ? `blink-${this.warningColor}` : '';
  }

  private calculateTimeDifference(): void {
    // Retrieve valid time interval data from session storage.
    const validSchedulePeriod = this.sessionStorageService.getSessionData(SESSION_STORAGE_KEY.validSchedulePeriod) || {};

    let lastTime : any = null;
    let lastHandle: any = null;
    this.data.forEach((x: any) =>{
      if(x.type == 9){
        // Check if the record is within a valid time period.
        if(!Utils.isRecordInValidPeriod(validSchedulePeriod, x.daiCd, x.time)) {
          return; // Skip this record, move to the next one
        }
        if(lastTime == null) lastTime = x;
        else if(new Date(lastTime.time) < new Date(x.time)) lastTime = x;
      }
      if(x.type == 6){
        // Check if the record is within a valid time period.
        if(!Utils.isRecordInValidPeriod(validSchedulePeriod, x.daiCd, x.time)) {
          return; // Skip this record, move to the next one
        }
        if(lastHandle == null) lastHandle = x;
        else if(new Date(lastHandle.time) < new Date(x.time)) lastHandle = x;
      }
    });
    if(
        // Only has handle records
        (!lastTime && lastHandle) ||
        // Both exist and are processed last if after the last defecation
        (lastHandle != null && lastTime != null && new Date(lastHandle.time) > new Date(lastTime.time))
    ) {
      this.dataMarquee.message = '(' + lastHandle.volume + ' : ' +
        (new Date(lastHandle.time).getMonth() + 1).toString().padStart(2, '0') + '/' +
        new Date(lastHandle.time).getDate().toString().padStart(2, '0') + ')';
    }
    this.hasExcreationRecord = lastTime != null;
    const now = this.timeService.getCurrentTime();
    let dataTime = new Date();
    if(lastTime!= null) dataTime = new Date(lastTime.time);
    const durationMs = now.getTime() - dataTime.getTime();

    const changeMINUTE = 60 * 1000;
    const changeHOUR = 60 * changeMINUTE;
    const changeDAY = 24 * changeHOUR;

    const days = Math.floor(durationMs / changeDAY);
    const remainingMsAfterDays = durationMs % changeDAY;
    const hours = Math.floor(remainingMsAfterDays / changeHOUR);

    this.dayDifference =  Math.max(0, isNaN(days) ? 0 : Math.floor(days));
    this.hourDifference = Math.max(0, Math.floor(hours));
    this.warningType = this.dayDifference || 0;
    this.warningColor = this.warningType >= 4 ? 'red' : this.warningType >= 3 ? 'yellow' : '';
  }
}